'use es6';

import { useContext } from 'react';
import get from 'transmute/get';
import { mapOf } from 'react-immutable-proptypes';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getDisplayName, getNonDefaultSource } from 'conversations-message-history/senders/operators/getters';
import { AsyncComponentsContext } from '../../thread-view/context/AsyncComponentsContext';
import { jsx as _jsx } from "react/jsx-runtime";
const ThreadPresenceAvatars = ({
  asyncSenders
}) => {
  const {
    AsyncUIAvatar
  } = useContext(AsyncComponentsContext);
  const lookups = asyncSenders.keySeq().toList().reduce((accumulator, locator) => {
    const asyncSender = get(locator, asyncSenders);
    const sender = getData(asyncSender);
    if (!sender) return accumulator;else return [...accumulator, {
      type: 'hubSpotUserEmail',
      displayName: getDisplayName(sender),
      src: getNonDefaultSource(sender)
    }];
  }, []);
  return /*#__PURE__*/_jsx(AsyncUIAvatar, {
    lookup: lookups,
    size: "xs",
    maxAvatars: 3
  });
};
ThreadPresenceAvatars.displayName = 'ThreadPresenceAvatars';
ThreadPresenceAvatars.propTypes = {
  asyncSenders: mapOf(RecordPropType('AsyncData'))
};
export default ThreadPresenceAvatars;